var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-contacts bottom-left-area"},[_vm._v("Офіс"),_c('br'),_vm._v("м. Тернопіль, вул. За Рудкою 18-20")])}]

export { render, staticRenderFns }